import {BreadcrumbType} from 'platform/components';

import {useAddInterestAssignmentConditionMutation} from '@dms/api/core';
import {i18n} from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';
import {handleApiError} from '@dms/shared';

import {ApiError, useNavigate} from 'shared/web';

import {AssignmentConditionForm} from '../../components/AssignmentConditionForm/AssignmentConditionForm';
import {
  AssignmentConditionFormValues,
  formValuesToRequestBody,
} from '../../components/AssignmentConditionForm/assignmentConditionFormSchema';

const breadcrumbs: BreadcrumbType[] = [
  {
    label: i18n.t('entity.interest.labels.interest'),
    href: settingsRoutes.interest,
  },
  {
    label: i18n.t('entity.interest.labels.SalesLeadsAssignment'),
    href: settingsRoutes.salesLeadsAssignment,
  },
];

export function SalesLeadsAssignmentNew() {
  const navigate = useNavigate();
  const [addCondition] = useAddInterestAssignmentConditionMutation();

  const handleSubmit = (
    values: AssignmentConditionFormValues,
    blockerContext?: {wasSubmittedFromBlocker?: boolean; reportApiFailure?: VoidFunction}
  ) =>
    addCondition({
      addInterestAssignmentConditionRequestBody: formValuesToRequestBody(values),
    })
      .unwrap()
      .then(() => {
        if (blockerContext?.wasSubmittedFromBlocker) {
          return;
        }
        navigate(settingsRoutes.salesLeadsAssignment);
      })
      .catch((e: ApiError) =>
        handleApiError(e, {signalApiError: blockerContext?.reportApiFailure})
      );
  const handleDiscard = (navigateWithoutBlocker: (path: string) => void) =>
    navigateWithoutBlocker(settingsRoutes.salesLeadsAssignment);

  return (
    <SettingsTemplate
      header={{
        title: i18n.t('entity.interest.labels.newCondition'),
        breadcrumbs,
      }}
      headerVariant="v2"
      data-testid={testIds.settings.salesLeadsAssignmentNew('page')}
    >
      <AssignmentConditionForm
        baseTestId={testIds.settings.salesLeadsAssignmentNew}
        onSubmit={handleSubmit}
        onDiscard={handleDiscard}
      />
    </SettingsTemplate>
  );
}
